import {PropsWithChildren, useMemo} from 'react';

import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';

import {SaveFiltersForm} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/sections/SaveFiltersForm';
import {useClientTagsDialogSection} from 'features/GlobalFilterProvider/filters/clientTags';
import {industriesDialogSection} from 'features/GlobalFilterProvider/filters/industries';
import {usePeriodDialogSection} from 'features/GlobalFilterProvider/filters/period';
import {usePolicyTagsDialogSection} from 'features/GlobalFilterProvider/filters/policyTags';
import {teamsDialogSection} from 'features/GlobalFilterProvider/filters/teams';
import {useGlobalFilterWarn} from 'features/GlobalFilterProvider/hooks/useGlobalFilterWarn';
import {FilterDialogProvider} from 'filters';
import {createActiveFiltersSection} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/ActiveFiltersSection';
import {useCreateRecentFiltersSection} from 'filters/features/FilterDialog/sections/RecentFiltersSection/RecentFiltersSection';
import {useCreateSavedFiltersSection} from 'filters/features/FilterDialog/sections/SavedFiltersSection/SavedFiltersSection';
import {marketDialogSection} from 'features/GlobalFilterProvider/filters/markets';
import {departmentsDialogSection} from 'features/GlobalFilterProvider/filters/departments';
import {locationDialogSection} from 'features/GlobalFilterProvider/filters/location';
import {productsDialogSection} from 'features/GlobalFilterProvider/filters/products';

import ClockIcon from 'components/icons/clock.svg';
import FiltersIcon from 'components/icons/filters.svg';
import SaveIcon from 'components/icons/saveSuccessful.svg';

const activeFiltersSection = createActiveFiltersSection({
  id: FilterDialogSectionId.ActiveFilters,
  title: 'Active Filters',
  appendContent: SaveFiltersForm,
  icon: FiltersIcon,
});

const savedFiltersConfig = {
  id: FilterDialogSectionId.SavedFilters,
  title: 'Saved Filters',
  icon: SaveIcon,
};

const recentFiltersConfig = {
  id: FilterDialogSectionId.RecentFilters,
  title: 'Recent Filters',
  icon: ClockIcon,
  withDivider: true,
};

export const GlobalFilterDialogProvider = ({children}: PropsWithChildren) => {
  const savedFiltersSection = useCreateSavedFiltersSection(savedFiltersConfig);
  const recentFiltersSection = useCreateRecentFiltersSection(recentFiltersConfig);
  const periodSection = usePeriodDialogSection();
  const policyTagsSection = usePolicyTagsDialogSection();
  const clientTagsSection = useClientTagsDialogSection();

  return (
    <FilterDialogProvider
      title='Decisions Filters'
      sections={useMemo(
        () =>
          [
            activeFiltersSection,
            savedFiltersSection,
            recentFiltersSection,
            periodSection,
            marketDialogSection,
            productsDialogSection,
            departmentsDialogSection,
            industriesDialogSection,
            teamsDialogSection,
            locationDialogSection,
            clientTagsSection,
            policyTagsSection,
          ].filter(Boolean),
        [clientTagsSection, periodSection, policyTagsSection, recentFiltersSection, savedFiltersSection]
      )}
      warn={useGlobalFilterWarn()}
    >
      {children}
    </FilterDialogProvider>
  );
};
